import $  from 'jquery';
import 'slick-carousel';
import { get } from 'lodash';

class Slider {
    constructor(el, options = {}) {
        this.el = $(el);
        this.slidesEl = el.find('.slider__slides');
        this.prevArrow = el.find('.slider__controls__prev');
        this.nextArrow = el.find('.slider__controls__next');
        this.loading = true;
        this.data = el.data();
        this.data = el.data();
        this.autoplay = get(this.data, ['autoplay'], 'false').toLowerCase() === 'true';
        this.autoplaySpeed = get(this.data, ['autoplaySpeed'], 4000);
        this.options = Object.assign({}, {
            infinite: true,
            autoplay: this.autoplay,
            autoplaySpeed: this.autoplaySpeed,
            slidesToShow: 1,
            dots: true,
            arrows: false,
            nextArrow: this.nextArrow,
            prevArrow: this.prevArrow,
            adaptiveHeight: false,
            mobileFirst: true,
            pauseOnHover: false,
            pauseOnFocus: false
        }, options);
        this.slick = this.slidesEl.slick(this.options);
    }
    getSlide(index) {
        return this.el.find('.slick-slide[data-slick-index="' + index + '"]');
    }
}

export default Slider;